import { render } from "./ParkingFleetDetails.vue?vue&type=template&id=35cd1bec&scoped=true"
import script from "./ParkingFleetDetails.vue?vue&type=script&lang=js"
export * from "./ParkingFleetDetails.vue?vue&type=script&lang=js"

import "./ParkingFleetDetails.vue?vue&type=style&index=0&id=35cd1bec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cd1bec"]])

export default __exports__